export class DescriptionListContentStyle {
  marginTop = 'uk-margin-remove-top';
  dropCap = '';
  size = 'uk-h5';
  font = 'tb-font-primary';

  static normalize(styles: Partial<DescriptionListContentStyle>): DescriptionListContentStyle {
    const pureStyles = new DescriptionListContentStyle();

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.dropCap = styles.dropCap ?? pureStyles.dropCap;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;

    return pureStyles;
  }
}
